import { getColorShade, getDefaultColor, locator } from "../helpers/common";
import { NoScaleSubType, INoScaleConfig, Locator, PointData, PointType, TooltipType } from "../types";
import { IFitPosition } from "@dhx/ts-common/html";
import BaseSeria from "./BaseSeria";


export default class NoScaleSeria extends BaseSeria {
	public config: INoScaleConfig;
	protected _textLocator: Locator;
	protected _colorLocator: Locator;
	protected _valueLocator: Locator;
	protected _gradient: any;

	protected _center: [number, number] = [0, 0]; // (x, y)
	protected _tooltipData: Array<[number, number]> = []; // (x, y)

	private _sum: number;

	scaleReady(sizes: IFitPosition) {
		for (const key in sizes) {
			sizes[key] += this.config.paddings;
		}
		return sizes;
	}

	dataReady(): PointData[] {
		const data = this._data;
		this._sum = data.reduce((sum, item) => item.$hidden ? sum : sum + parseFloat(this._valueLocator(item)), 0);
		this._points = data.reduce((items, item, i) => {
			if (item.$hidden) {
				return items;
			}
			const t = this._textLocator(item);
			const v = this._valueLocator(item);
			const x = v/this._sum;
			const c =  this._colorLocator ? this._colorLocator(item) : getDefaultColor(i);
			items.push([x, v, item.id, t, c]);
			return items;
		}, []);

		return this._points;
	}
	toggle(id?: string) {
		const item = this._data.getItem(id);
		if (!item) {
			return;
		}
		this._data.update(id, {$hidden: !item.$hidden});
	}
	getClosest(x: number, y: number): [number, number, number, string] {
		let percent = 1 - (Math.atan2(x - this._center[0], y - this._center[1]) + Math.PI) / Math.PI / 2;

		const points = this._points;
		for (let i=0; i<points.length; i++) {
			if (points[i][0] >= percent) {
				return [0, this._tooltipData[i][0], this._tooltipData[i][1], points[i][2]];
			}
			percent -= points[i][0];
		}
		return [Infinity, null, null, null];
	}
	getTooltipText(id:string){
		if (this.config.tooltip) {
			const p = this._defaultLocator(this._data.getItem(id));
			if (this.config.tooltipTemplate) {
				return this.config.tooltipTemplate(p);
			}
			return p[0];
		}
	}
	getTooltipType(_id: string) {
		return TooltipType.simple;
	}
	protected _setDefaults(config: INoScaleConfig) {
		const defaults = {
			subType: NoScaleSubType.basic,
			paddings: 20
		};
		this.config = {...defaults, ...config};
		this._drawPointType = this._getPointType(PointType.empty, "none", this.config.tooltip);
		this._valueLocator = locator(config.value);
		this._textLocator = locator(config.text);
		if (config.color) {
			this._colorLocator = locator(config.color);
		} else if (config.monochrome) {
			this._colorLocator = item => getColorShade(config.monochrome, this._getPercent(item) * 2); // 2 for more bright
		}
	}
	protected _defaultLocator(v) {
		return [this._valueLocator(v), this._textLocator(v)];
	}
	private _getPercent(item: any): number {
		return parseFloat(this._valueLocator(item)) / this._sum;
	}
}